module.exports = __webpack_public_path__ + "img/P150T_weapon_122.9298f864.png";